import styled, { css } from 'styled-components'
import { getSpacerSize } from '@utils/getSpacerSize'

export const IngegnoWrapper = styled.div`
  max-width: 760px;
`

export const Ingegno = styled.div`
  background-image: url(${({ theme }) => theme.images.ingegnoBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  ${({ space }) => space && getSpacerSize(space, 'padding')};

  ${({ theme, colorScheme }) =>
    colorScheme &&
    css`
      color: ${theme.colors.surface[colorScheme].text};
    `}
    
  ${({ isFocus }) =>
    isFocus &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.secondary.default};
    `}

  ${({ align }) =>
    align &&
    css`
      text-align: ${align};

      ${IngegnoWrapper} {
        margin: 0 ${align == 'center' ? 'auto' : 0};
      }
    `}
`

export const IngegnoTitle = styled.div`
  margin-top: ${({ theme }) => theme.rem(16)};
`

export const IngegnoParagraph = styled.div`
  margin-top: ${({ theme }) => theme.rem(16)};
`

export const IngegnoButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.rem(32)};
`
export const IngegnoImage = styled.div`
  width: 500px;
  height: 420px;
  position: relative;
  margin-top: ${({ theme }) => theme.rem(32)};
  margin-bottom: ${({ theme }) => theme.rem(64)};
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) =>
    theme.mediaQuery.md(
      `
    width: 100%;
    height: 360px;
  `,
      true
    )};
`
